import { CommandBarButton, TooltipHost } from "@fluentui/react";
import { TFunction } from "i18next";
import React from "react";

type Props = {
  className?: string;
  isActive: boolean;
  onClick?: () => void;
  text?: string;
  t: TFunction;
};

export const ColumnOptionsButton = ({
  className,
  isActive,
  onClick,
  text,
  t,
}: Props) => {
  const label = text ?? t("greco.columnOptions");
  return (
    <TooltipHost content={label}>
      <CommandBarButton
        className={className}
        onClick={onClick}
        iconProps={{ iconName: isActive ? "FilterSolid" : "Filter" }}
        text={label}
        styles={{
          root: {
            whiteSpace: "nowrap",
            minHeight: 44,
            background: "transparent",
          },
        }}
      />
    </TooltipHost>
  );
};
